(<template>
  <div class="choose-role-btn">
    <div :class="[`choose-role-btn__img--${params.type}`]"
         class="choose-role-btn__img"></div>
    <div class="choose-role-btn__content-wrapper">
      <h6 class="choose-role-btn__title">{{ params.title }}</h6>
      <p class="choose-role-btn__description">{{ params.description }}</p>
      <button class="choose-role-btn__action">{{ params.btnText }}</button>
    </div>
  </div>
</template>)

<script>
  export default {
    props: {
      params: {
        type: Object,
        default() {
          return {};
        }
      }
    }
  };
</script>

<style scoped>
.choose-role-btn {
  display: flex;
  flex-direction: column;
  width: 256px;
  border-radius: 8px;
  background: var(--color-white);
  box-shadow: var(--block-shadow);
  cursor: pointer;
}

.choose-role-btn__content-wrapper {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  padding: 20px 24px 24px;
}

.choose-role-btn__img {
  display: block;
  width: 100%;
  height: 140px;
  background-position: center;
  background-repeat: no-repeat;
}

.choose-role-btn__img--server {
  background-image: url(~@assets/imgs/wizard_icons/interpreter_illustration.svg);
}

.choose-role-btn__img--employee {
  background-image: url(~@assets/imgs/wizard_icons/bussiness_illustration.svg);
}

.choose-role-btn__img--buyer {
  background-image: url(~@assets/imgs/wizard_icons/private_person_illustration.svg);
}

.choose-role-btn__title {
  font-size: 15px;
  text-align: left;
}

.choose-role-btn__description {
  height: 100%;
  margin: 10px 0 20px;
  color: #333;
  text-align: left;
}

.choose-role-btn__action {
  padding: 8px 0;
  border: 1px solid var(--tertiary-border-color);
  border-radius: 4px;
  background-color: var(--tertiary-background-color);
  color: var(--tertiary-text-color);
}

.choose-role-btn:hover .choose-role-btn__action {
  background-color: var(--color-primary);
  color: var(--color-white);
}

.choose-role-btn__action:focus {
  box-shadow: inset 0 0 0 2px #3af;
}

@media (max-width: 670px) {
  .choose-role-btn {
    width: 100%;
    max-width: 345px;
    margin-bottom: 20px;
  }

  .choose-role-btn__img {
    background-size: cover;
  }

  .choose-role-btn__action {
    background-color: var(--color-primary);
    color: var(--color-white);
  }
}
</style>
